export const validateForm = (formData, validationFlags, countries = []) => {
  const newErrors = {};
  const {
    shouldShowSoftwareType,
    shouldShowSerialNumbers,
    shouldShowNumberOfUsers,
    shouldShowPortability,
    shouldShowDeliveryMethod,
    shouldShowLicenseScope,
  } = validationFlags || {};

  // Always required fields
  if (!formData.recipient_name?.trim()) {
    newErrors.recipient_name = 'Recipient name is required';
  }
  if (!formData.company_name?.trim()) {
    newErrors.company_name = 'Company name is required';
  }
  if (!formData.email?.trim()) {
    newErrors.email = 'Email is required';
  } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
    newErrors.email = 'Please enter a valid email address';
  }
  if (!formData.phone_number?.trim()) {
    newErrors.phone_number = 'Phone number is required';
  }
  if (!formData.looking_for) {
    newErrors.looking_for = 'Please select what you are looking for';
  }
  if (shouldShowDeliveryMethod && !formData.delivery_method) {
    newErrors.delivery_method = 'Please select a delivery method';
  }
  if (!formData.billing_address?.trim()) {
    newErrors.billing_address = 'Billing address is required';
  }
  if (!formData.billing_city?.trim()) {
    newErrors.billing_city = 'Billing city is required';
  }
  if (!formData.billing_country?.trim()) {
    newErrors.billing_country = 'Billing country is required';
  }
  if (!formData.billing_zip_code?.trim()) {
    newErrors.billing_zip_code = 'Billing zip code is required';
  }
  if (!formData.delivery_address?.trim()) {
    newErrors.delivery_address = 'Delivery address is required';
  }
  if (!formData.delivery_city?.trim()) {
    newErrors.delivery_city = 'Delivery city is required';
  }
  if (!formData.delivery_country?.trim()) {
    newErrors.delivery_country = 'Delivery country is required';
  }
  if (!formData.delivery_zip_code?.trim()) {
    newErrors.delivery_zip_code = 'Delivery zip code is required';
  }

  ['billing', 'delivery'].forEach((prefix) => {
    const country = countries.find(
      (candidate) => String(candidate.id) === String(formData[`${prefix}_country`]),
    );

    if (country?.states?.length && !formData[`${prefix}_state`]?.trim()) {
      newErrors[`${prefix}_state`] = `Please select a ${prefix} state or province`;
    }
  });

  // Conditional validations based on license type and other conditions
  if (shouldShowSoftwareType && !formData.software_type) {
    newErrors.software_type = 'Please select a software type';
  }

  if (shouldShowSerialNumbers && !formData.serial_numbers?.trim()) {
    newErrors.serial_numbers = 'Serial numbers are required for license renewal';
  }

  if (shouldShowNumberOfUsers) {
    if (formData.software_type === 'viewmate_business') {
      const usersCount = Number(formData.number_of_users);
      if (!Number.isInteger(usersCount)) {
        newErrors.number_of_users = 'Please enter a valid number of licenses or users';
      } else if (formData.license_scope === 'site' && usersCount < 10) {
        newErrors.number_of_users = 'Site licenses require at least 10 users';
      } else if (formData.license_scope !== 'site' && (usersCount < 1 || usersCount > 5)) {
        newErrors.number_of_users = 'Regular licenses allow 1 to 5 users';
      }

    } else if (!formData.number_of_users) {
      newErrors.number_of_users = 'Please select the number of users';
    }
  }

  if (shouldShowLicenseScope && !formData.license_scope) {
    newErrors.license_scope = 'Please select a quote type';
  }

  if (shouldShowPortability && !formData.portability_option) {
    newErrors.portability_option = 'Please select a portability option';
  }

  return newErrors;
};
